import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { SearchTermservice } from '../../services/search/search-service.service';
import { StatesService } from '../../services/states/states.service';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
import { ChangeLogService } from '../../services/change_log/change-log.service';

@Component({
  selector: 'app-add-agent-employee-dialog',
  templateUrl: './add-agent-employee-dialog.component.html',
  styleUrls: ['./add-agent-employee-dialog.component.css']
})
export class AddAgentEmployeeDialogComponent implements OnInit {
  states: any;
  EmploymentType = ["Owner", "Manager", "Lot Attendant", "Office Staff", "Recovery Driver"];
  data: any = {
    firstName: '',
    middleName: '',
    lastName: '',
    employeeType: '',
    bcDate: '',
    employeeAddress: '',
    employeeCity: '',
    employeeState: '',
    employeeZip: '',
    docId: ''
  }
  employeeDetails: any;
  errMsg;
  errFlag: boolean = false;
  addrFlag: boolean = false;
  agentId: any;
  loginId: any;
  submitSuccess;
  message;
  id: any;
  editList: any;
  placeholder = 'Select a Address';
  private subscription: any;
  vendorLocationDetails: any[] = [];
  logFormData: any;

  constructor(private locationService: AgentlocationService,
    private AgentEmployeeService: AgentEmployeeService,
    private statesService: StatesService,
    private changelogservice: ChangeLogService,
    public dialogRef: MatDialogRef<AddAgentEmployeeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public employeeData: any) { }

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
    this.getAllStates();
    this.getLocationDetails(this.agentId);
    if (this.employeeData !== null) {
      this.getEmployeeDetailsToEdit();
    }
  }
  placeholderChange() {
    this.placeholder = "Address"
  }

  getLocationDetails(agentId) {
    let locationStatus = "Active Locations"
    this.locationService.getAgentLocationDetails(agentId, locationStatus).subscribe(res => {
      if (res.Status == 200 && res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length > 0) {
        this.vendorLocationDetails = res.vendorLocationDetails;
      }
      else if (res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length == 0) {
        this.addrFlag = true;
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    })
  }

  onChange(val) {
    let selectedLocationAddress = this.vendorLocationDetails.filter(add => add.Address1 === val.value);
    this.data.employeeCity = selectedLocationAddress[0].City,
      this.data.employeeZip = selectedLocationAddress[0].PostalCode;
    this.data.employeeState = selectedLocationAddress[0].State;

  }

  getEmployeeDetailsToEdit() {
    this.data.firstName = this.employeeData.employeeData.FirstName;
    this.data.lastName = this.employeeData.employeeData.LastName;
    this.data.employeeType = this.employeeData.employeeData.EmployeeType;
    this.data.bcDate = this.employeeData.employeeData.BackgroundCheckCompletionDate;
    this.data.employeeAddress = this.employeeData.employeeData.Address1;
    this.placeholder = this.employeeData.employeeData.Address1 ? 'Address' : 'Select a Address';
    this.data.employeeCity = this.employeeData.employeeData.City;
    this.data.employeeState = this.employeeData.employeeData.State;
    this.data.employeeZip = this.employeeData.employeeData.PostalCode;
    this.data.docId = this.employeeData.employeeData._id;
    this.data.employeeState = this.employeeData.employeeData.State;
  }
  getAllStates() {
    this.statesService
      .getStates()
      .subscribe(res => {
        this.states = res.States;
      }
      );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onFormSubmit(form: NgForm) {
    this.employeeDetails = form.value;
    this.employeeDetails._id = this.data.docId;
    if (this.employeeDetails.bcDate == null) {
      this.employeeDetails.bcDate = "";
    }
    if (this.data.docId) {
      this.AgentEmployeeService.employeeedited(this.employeeDetails, this.agentId).subscribe(res => {
        if (res.Info == 'Updated Employee Details') {
          this.submitSuccess = true;
          this.message = 'Agent Employee updated successfully';
          this.AgentEmployeeService.load.next('success');
          this.onNoClick();
          this.logFormData = {
            "document_type": "Employee",
            "document_category": "Employee",
            "transaction_type": "Edit",
            "vendor_id": this.agentId
          }
          this.logFormData.modified_by = this.loginId;
          this.logFormData.employee_name = this.employeeDetails.firstName + " " +this.employeeDetails.lastName;
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errMsg = err;
            this.errFlag = true;
          });
        }
      }, err => {
        this.errMsg = err;
        this.errFlag = true;
      });
    }
    else {
      this.AgentEmployeeService.addAgentEmployees(this.employeeDetails).subscribe(res => {
        if (res.Status == 200) {
          this.submitSuccess = true;
          this.message = 'Agent Employee added successfully';
          this.AgentEmployeeService.load.next('success');
          this.onNoClick();
          this.logFormData = {
            "document_type": "Employee",
            "document_category": "Employee",
            "transaction_type": "Add",
            "vendor_id": this.agentId
          }
          this.logFormData.modified_by = this.loginId;
          this.logFormData.employee_name = this.employeeDetails.firstName + " " +this.employeeDetails.lastName;
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errMsg = err;
            this.errFlag = true;
          });
        }
      }, err => {
        this.errMsg = err;
        this.errFlag = true;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/add-agent-employee-dialog/add-agent-employee-dialog.component.ts